import classcat from "classcat";
import React from "react";

import { IconUp } from "@touchtech/web-baselayer-ui";

import css from "./Pagination.module.css";
import useManagePagination from "./hooks/useManagePagination";

type Props = {
  currentPage: number;
  pageCount: number;
  onPageChange: (page: number) => void;
  className?: string;
};

const Pagination = ({
  currentPage,
  pageCount,
  className,
  onPageChange,
}: Props) => {
  const { pagesRange, handleNextClick, handlePageChange, handlePrevClick } =
    useManagePagination({
      currentPage,
      pageCount,
      onPageChange,
    });

  return (
    <div className={classcat([css.container, className])}>
      <button
        className={classcat([
          css.prevButton,
          { [css.disabled]: currentPage === 1 },
        ])}
        disabled={currentPage === 1}
        onClick={handlePrevClick}
        data-testid="prev-button"
      >
        <IconUp />
      </button>
      {pagesRange.map((page, index) => (
        <button
          key={`${page}-${index}`}
          className={classcat([
            "text-label-base",
            css.pageButton,
            { [css.selected]: page === currentPage },
          ])}
          onClick={handlePageChange(page)}
        >
          {page}
        </button>
      ))}
      <button
        className={classcat([
          css.nextButton,
          { [css.disabled]: currentPage === pageCount },
        ])}
        disabled={currentPage === pageCount}
        onClick={handleNextClick}
        data-testid="next-button"
      >
        <IconUp />
      </button>
    </div>
  );
};

export default Pagination;
